export const DEV_URL = 'https://staging.sparkbackend.cerebry.co/';
